import { render, staticRenderFns } from "./DragDropImage.vue?vue&type=template&id=dac0246a&"
import script from "./DragDropImage.vue?vue&type=script&lang=js&"
export * from "./DragDropImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports